import { auth, redirect } from "./index";

export default [
  {
    path: "",
    name: "home",
    component: () => import("../views/dashboard"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/login",
    name: "login",
    component: () => import("../views/accounts/login"),
    meta: {
      middleware: [redirect],
    },
  },

  {
    path: "/register",
    name: "Register",
    component: () => import("../views/accounts/register"),
  },

  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/accounts/forgot-password"),
    meta: {
      middleware: [redirect],
    },
  },

  {
    path: "/email-confirmation",
    name: "Email confirmation",
    component: () => import("../views/accounts/email-confirmation"),
    meta: {
      middleware: [redirect],
    },
  },

  {
    path: "/invite-employee",
    name: "Invite employee",
    component: () => import("../views/accounts/invite-employee"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/lodgings",
    name: "Lodgings",
    component: () => import("../views/lodgings/index"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/employees",
    name: "Employees",
    component: () => import("../views/employees/index"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/calendar",
    name: "Calendar",
    component: () => import("../views/calendar/index"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/customers",
    name: "Customers",
    meta: {
      middleware: [auth],
    },
    component: () => import("../views/customers/index"),
  },

  {
    path: "/bookings",
    name: "Bookings",
    component: () => import("../views/bookings/index"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/bookings/:id",
    name: "Booking",
    component: () => import("../views/bookings/show"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/settings",
    name: "Settings",
    component: () => import("../views/settings"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/settings/prices",
    name: "Prices",
    component: () => import("../views/prices/index"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/settings/additional_costs",
    name: "Additional Costs",
    component: () => import("../views/additional_costs/index"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/settings/discounts",
    name: "Discounts",
    component: () => import("../views/discounts/index"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/settings/rules",
    name: "Rules",
    component: () => import("../views/rules/index"),
    meta: {
      middleware: [auth],
    },
  },

  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/profile"),
    meta: {
      middleware: [auth],
    },
  },
];
